import { find, filter } from 'lodash';
import moment from 'moment';
import { mapState } from 'vuex';

export default {
  /* eslint-disable*/
  props: {
    booking: {
      id: Number,
      title: String,
      description: String,
      updated_by: Object,
      end_date: [String, Date],
      start_date: [String, Date],
      invites_list: {
        type: Array,
        default: [],
      },
      user_id: Number,
    },
  },

  methods: {
    getBookingsByHour: (bookings, hour) =>
      filter(bookings, (booking) => {
        const startHour = (new Date(booking.start_date)).getHours();
        const endsHour = (new Date(booking.end_date)).getHours();
        return (hour >= startHour) && (hour <= endsHour);
      }),
    getDate(dateOrString) {
      return (typeof dateOrString === typeof String) ? new Date(dateOrString) : dateOrString;
    },
    getTime(date) {
      return moment(date).format('hh:mm a');
    },
    getBookingById: (bookings, id) => find(bookings, booking => booking.id === id),
    getAdjustedDate(date) {
      return moment(date).set({
        day: this.selectedDate.day(),
        month: this.selectedDate.month(),
        year: this.selectedDate.year(),
      });
    },

    // Controls LED color for BrightSign LED equipped devices
    setBSHWLED: (color) => {
      try {
        const cp = new BSControlPort('BrightSign');

        cp.ConfigureAsOutput(2);
        cp.ConfigureAsOutput(3);

        console.warn('Setting BSHWLED to: '+ color)

        switch (color) {
          case 'off':
            cp.SetPinValue(2, 0);
            cp.SetPinValue(3, 0);
            break
          case 'red':
            cp.SetPinValue(2, 1);
            cp.SetPinValue(3, 0);
            break
          case 'green':
            cp.SetPinValue(2, 0);
            cp.SetPinValue(3, 1);
            break
          case 'yellow':
            cp.SetPinValue(2, 1);
            cp.SetPinValue(3, 1);
            break
        }
      }
      catch (error) {
        // if(String(error).search('BSControlPort'))
        // console.warn('Device does not support Brightsign Control Port.')
      }
    },
  },

  computed: {
    ...mapState(['selectedDate']),
    startTime() {
      return this.getTime(this.getDate(this.booking.start_date));
    },
    endTime() {
      return this.getTime(this.getDate(this.booking.end_date));
    },
    schedule() {
      return `${this.startTime} - ${this.endTime}`;
    },
    email() {
      return this.booking.created_by.email;
    },
    invitesList() {
      return this.booking.invites_list;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/booking-mixins.js